import React, { useEffect, useState } from 'react';
import './operationsoverview.scss';
import Donut from '../../components/Donut/Donut';
import { NavLink, useNavigate } from 'react-router-dom';
import base from '../../apis';
import { Loader } from '@mantine/core';
import useFetch from '../../hooks/useFetch';
import { Grid } from '@mui/material';
import useTargets from '../../hooks/useTargets';
function OperationsOverview() {
  // const navigate = useNavigate();
  return (
    <div className="operationsoverview">
      <div className="operationsoverview__first">
        <div className="operationsoverview__first-first">
          <h3>
            SALES VALUE - <span>2022</span>
          </h3>
          <Grid container spacing={2}>
            <Grid item xl={6}>
              <Donuter type="Month" />
            </Grid>
            <Grid item xl={6}>
              <Donuter type="Year" />
            </Grid>
          </Grid>

          <NavLink to="/">View this year's sales target</NavLink>
        </div>
        {/* <div className="operationsoverview__first-last">
          <h3>Top 3 Teams of the Month</h3>
          <div>
            <h5>Team Name</h5>
            <div>
              <Users />
              <span className="mem">6 Members</span>
            </div>
            <div>
              <Award />
              <span className="sub">65 BPO Farm Agent Subscriptions</span>
            </div>
          </div>
          <div>
            <h5 className="white">Team Name</h5>
            <div>
              <Users />
              <span className="mem">6 Members</span>
            </div>
            <div>
              <Award />
              <span className="sub">65 BPO Farm Agent Subscriptions</span>
            </div>
          </div>
          <div>
            <h5 className="gold">Team Name</h5>
            <div>
              <Users />
              <span className="mem">6 Members</span>
            </div>
            <div>
              <Award />
              <span className="sub">65 BPO Farm Agent Subscriptions</span>
            </div>
          </div>
        </div> */}
      </div>
      <div className="operationsoverview__details">
        <SubMonth />
        <ViewTeams />
      </div>
    </div>
  );
}

export default OperationsOverview;

const ref = [
  { name: 'bpo_farm', label: 'BPO Farm Agent', path: '' },
  { name: 'premier_agent_website', label: 'BPO Premier Agent', path: '' },
  { name: 'deal_analyzer', label: 'BPO Deal Analyzer', path: '' },
  { name: 'combo_package', label: 'BPO Combo Package', path: '' },
];

const SubMonth = () => {
  const navigate = useNavigate();
  const [subs, setSubs] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    base
      .get('compensations/operations-compensation-package-view/', {
        params: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
        },
      })
      .then(({ data }) => {
        setSubs(data);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className="operationsoverview__details-first">
        <Loader size="lg" sx={{ margin: '20px auto' }} />
      </div>
    );
  }

  return (
    <div className="operationsoverview__details-first">
      <h3>Subscriptions this month</h3>
      {ref.map((item, index) => (
        <div key={item.name} onClick={() => navigate('/subscription-overview/BPO-farm-agent')}>
          <span>{item.label}</span>
          <b>{subs?.[item.name]}</b>
        </div>
      ))}

      <hr />
      <p>
        A total of <b>{ref.map((item) => subs?.[item.name]).reduce((cur, acc) => cur + acc, 0) || 0}</b> subscription
        this month
      </p>
    </div>
  );
};

const ViewTeams = () => {
  const { data, isLoading } = useFetch('operations/marketing_teams/count');

  return (
    <div className="operationsoverview__details-last">
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <p>
            <b>{data?.team_count || 0}</b> Teams created so far.{' '}
          </p>
          <NavLink to="/mart-exec-teams">View Teams</NavLink>
        </div>
      )}
    </div>
  );
};

/**
 *
 * @param {'Month'|'Year' } type
 * @returns
 */
const Donuter = ({ type }) => {
  const { isLoading, selectedMonth, selectedYear } = useTargets();
  let url = `/compensations/operations-compensation-view-amount/?year=${new Date().getFullYear()}`;
  if (type === 'Month') {
    url += `&month=${new Date().getMonth() + 1}`;
  }
  const { data, isLoading: isLoadingAmount } = useFetch(url);
  if (isLoading || isLoadingAmount) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader color="dark" />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <p>{type.toUpperCase()}</p>
      <Donut
        total={{ ...(type === 'Month' ? selectedMonth : selectedYear) }?.amount || 0}
        current={data?.package_amount || 0}
      />
      <span> $ {Number({ ...(type === 'Month' ? selectedMonth : selectedYear) }?.amount || 0).toLocaleString()}</span>
    </div>
  );
};
